import ConditionValidator from "./conditionValidator.service";

angular
  .module("acl.visualizer.condition", ["acl.visualizer.conditionalOperators"])
  .service("ConditionValidator", ConditionValidator);
